import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal } from '@angular/core';
import { UiStateTone } from '../../types/ui-state-tone.type';

@Component({
  selector: 'ui-stat',
  imports: [],
  templateUrl: './ui-stat.component.html',
  styleUrl: './ui-stat.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiStatComponent {
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly value: InputSignal<string> = input.required<string>();
  public readonly description: InputSignal<string | null> = input<string | null>(null);
  public readonly tone: InputSignal<UiStateTone> = input<UiStateTone>('neutral');

  protected readonly hasDescription: Signal<boolean> = computed((): boolean => !!this.description());
  protected readonly isNeutral: Signal<boolean> = computed((): boolean => this.tone() === 'neutral');
  protected readonly isInfo: Signal<boolean> = computed((): boolean => this.tone() === 'info');
  protected readonly isSuccess: Signal<boolean> = computed((): boolean => this.tone() === 'success');
  protected readonly isWarning: Signal<boolean> = computed((): boolean => this.tone() === 'warning');
  protected readonly isDanger: Signal<boolean> = computed((): boolean => this.tone() === 'danger');
}
